import { render, staticRenderFns } from "./keeping-exotic-pets.vue?vue&type=template&id=625c9ae8&"
import script from "./keeping-exotic-pets.vue?vue&type=script&lang=js&"
export * from "./keeping-exotic-pets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports